// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"897067bb","320":"7569be9c","759":"bd803490","893":"6cdf75c9"}[chunkId] + ".chunk.js";
};